
import moment from "moment";
import { mapState, mapStores } from "pinia";
import { NTooltip } from "naive-ui";
import { defineComponent, PropType } from "vue";

import WidgetBase, { WidgetMode } from "./widget.vue";
import { useDashboardStore } from "~/store/dashboard.store";
import WidgetContentBase from '~/components/widgets/widget-content-base';
import { StationIconeResponse } from "~/api/models/icone-response.model";

const lastWeek = moment().subtract(1,'w');
const fake: StationIconeResponse = {
    icone: 2,
    valid: true,
    week: lastWeek.weeksInYear(),
    year: lastWeek.year(),
    start: lastWeek.startOf('week').toISOString(),
    end: lastWeek.endOf('week').toISOString(),
    timeslots: [],
    n0: 0,
    n1: 0,
    n2: 0,
    max_between_measure: 950,
}

export default defineComponent({

    extends: WidgetContentBase,

    components: {
        NTooltip,
    },

    data() {
        const now = moment();
        const week = {
            start: now.clone().subtract(1, 'w').startOf('week'),
            end: now.clone().subtract(1, 'w').endOf('week'),
            mean: [],
        };

        return {
            iconeLabel: [
                this.$t('dashboard.icone_widget.no_confinement'),
                this.$t('dashboard.icone_widget.weak_confinement'),
                this.$t('dashboard.icone_widget.middle_confinement'),
                this.$t('dashboard.icone_widget.high_confinement'),
                this.$t('dashboard.icone_widget.very_high_confinement'),
                this.$t('dashboard.icone_widget.extreme_confinement'),
            ],
        };
    },

    computed: {
        ...mapStores(useDashboardStore),
        ...mapState(useDashboardStore, ['currentStation', 'icone']),

        currentICONE(): StationIconeResponse {
            return this.fake ? fake: this.icone;
        },

        iconeValue(): number {
            return this.currentICONE?.icone !== null && this.currentICONE?.icone !== undefined ? this.currentICONE?.icone :  2;
        },

        positionClass() {
            return !isNaN(this.iconeValue) ? `pos-${this.iconeValue}`: ''
        },

        isValid() {
            return this.currentICONE?.valid;
        },

        week() {
            return {
                start: this.currentICONE ? moment().week(this.currentICONE.week).startOf('week'): null,
                end: this.currentICONE ?  moment().week(this.currentICONE.week).endOf('week'): null,
                mean: this.currentICONE?.timeslots.map(t => t.mean),
            }
        },

        mean(): number[] {
            return this.currentICONE?.timeslots.map(t => t.mean);
        }
    },
});

